var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrap",class:{ 'is-checked': _vm.isChecked },on:{"click":_vm.toggle}},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.toggle}}),_c('span',{staticClass:"switch-core",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }